<script>
  import Scatter from "./Scatter.svelte";
  import Scroller from "./Scroller.svelte";
  import Text from "./Text.svelte";
  import * as copy from "./../content/data.json";

  let scrollIndex = 0;

  const groupOptions = copy.dots.map(d => ({
    text: d["text"],
    dims: d["dimensions"].split(",").map(d => d.trim()),
    xScaleLabel: d["x_scale_label"] || "",
    yScaleLabels: (d["y_scale_labels"] || "").split(",").map(d => d.trim())
  }));

  $: group = groupOptions[Math.min(scrollIndex, groupOptions.length - 1)] || [];
</script>

<div class="c">
  <Scroller bind:index="{scrollIndex}">
    <div slot="foreground">
      {#each groupOptions as { text }}
        <section>
          <div class="blurb blurb-bg">
            <Text {text} />
          </div>
          <div class="blurb">
            <Text {text} />
          </div>
        </section>
      {/each}
    </div>

    <div slot="background" class="background">
      <Scatter
        dims="{group.dims}"
        yScaleLabels="{group.yScaleLabels}"
        xScaleLabel="{group.xScaleLabel}" />
    </div>
  </Scroller>
</div>

<style>
  .c {
    margin-top: -3em;
    margin-bottom: 13em;
  }
  section {
    padding: 20vh 0 60vh 0;
    pointer-events: none;
    display: flex;
    text-align: left;
  }
  section:first-of-type {
    padding-top: 22vh;
  }
  section:last-of-type {
    /* padding-bottom: 71vh; */
  }
  .blurb {
    /* margin: auto; */
    /* padding: 1em 2em; */
    max-width: 23em;
    /* background: white;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 15px -5px; */
    z-index: 10;
  }
  .blurb-bg {
    -webkit-text-stroke: 4px black;
    z-index: 1;
    position: absolute;
  }
  .background {
    position: relative;
    height: 100vh;
    pointer-events: all;
  }
</style>
